import { MainMenuComponent } from './main-menu/main-menu.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, Platform } from '@ionic/angular';
import { CoreModule } from './_core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomTranslateLoader } from './_core/services/custom-translate-loader.service';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { END_POINT, SOCKET_PATH, SOCKET_URL, environment } from '../environments/environment';

import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { Capacitor } from '@capacitor/core';
import { NoInternetModule } from './no-internet/no-internet.module'; // ✅ Import this
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new CustomTranslateLoader(httpClient);
}

const config: SocketIoConfig = {
  url: SOCKET_URL,
  options: {
      reconnection: true,
      reconnectionDelay: 5000,
      reconnectionDelayMax: 15000,
      reconnectionAttempts: 5,
      query: {
        origin: END_POINT
      },
      path: SOCKET_PATH,
      transports: ['websocket', 'polling'],
      forceNew: true,
      autoConnect: true,
  }
};

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: Capacitor.isNativePlatform() || !environment.production ? 'localhost' : 'ioncourt.com'
  },
  enabled: Capacitor.getPlatform() === 'android' ? false : true,
  palette: {
    popup: {
      background: '#f4f5f8'
    },
    button: {
      background: '#3f51b5'
    }
  },
  theme: 'classic',
  type: 'info',
  content: {
    dismiss: 'Agree',
    message: 'Our app uses cookies to ensure you have the best experience. By continuing to browse, you agree to our use of cookies.',
    href: 'app/coockie-policy',
    target: '_self'
  }
};

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        CoreModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        NoInternetModule,
        SocketIoModule.forRoot(config),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        FormsModule,
        MainMenuComponent,
        ReactiveFormsModule,
        RecaptchaV3Module,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en',
            isolate: false
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        }),
        NgcCookieConsentModule.forRoot(cookieConfig)
    ],
    providers: [
        DatePipe,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPTCHA_SITE_KEY }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
